import React from "react";
import "./Home.css";

const Home = () => {
  return <h1 className="text-3xl font-bold text-center py-5">Coming soon...</h1>;
};

export default Home;
